import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { OverlayContext } from 'contextProviders/OverlayContext';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { useErrorSnackbar } from 'hooks/useErrorSnackbar';
import { exportAnalysisToFile } from 'utils/exportAnalysisUtil';
import { generateDiscountArray } from 'utils/generateDiscountArray';
import DiscountCell from './components/DiscountCell/DiscountCell';
import './DiscountTable.scss';


const DiscountTable = ({ analysis, matrix, price, costPrice, isFixedPrice }) => {
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const { getAnalysisExcelDownload } = PricelistApis();
  const [discountLevels, setDiscountLevels] = useState([]);
  const showError = useErrorSnackbar();

  const exportAnalysis = useCallback(() => {
    exportAnalysisToFile({
      analysis,
      matrix,
      setShowLoadingOverlay,
      setDownloadErrorSnackbar: showError,
      getAnalysisExcelDownload
    });
  }, [analysis, matrix, showError, setShowLoadingOverlay, getAnalysisExcelDownload]);

  useEffect(() => {
    setDiscountLevels(generateDiscountArray());
  }, []);

  return isFixedPrice ? (
    <Box className="fixedPriceTab">
      <h2>This analysis is Fixed Price</h2>
      <p>CostPrice: ${costPrice ?? 'TBA'}</p>
      <p>&nbsp;</p>
      <Button className="btnAnalysisExport" onClick={exportAnalysis}>Export</Button>
    </Box>
  ) : (
    <Box className="discountTable">
      {discountLevels?.map((discount) => (
        <DiscountCell key={discount} discountLevel={discount} price={price} />
      ))}
      <Box className="discountCell">
        <p style={{ background: '#FFD98F' }}>Cost</p>
        <p>${costPrice ?? 'TBA'}</p>
      </Box>
      <Box className="discountCell">
        <Button className="btnAnalysisExport" onClick={exportAnalysis}>Export</Button>
      </Box>
    </Box>
  );
};

export default DiscountTable;
